export default ({ $config }) => {
  return {
    httpEndpoint: $config.apiDomain ? $config.apiDomain + '/graphql' : "http://localhost:1337/graphql"
  }
}